<template lang="pug">
.container-pts.outline(
  tabindex="-1", v-focus="",
  @keyup.49="validarPontoASerBatido('Entrada')",@keyup.97="validarPontoASerBatido('Entrada')",
  @keyup.50="validarPontoASerBatido('Pausa')",@keyup.98="validarPontoASerBatido('Pausa')",
  @keyup.51="validarPontoASerBatido('Retorno Pausa')",@keyup.99="validarPontoASerBatido('Retorno Pausa')",
  @keyup.52="validarPontoASerBatido('Saída')",@keyup.100="validarPontoASerBatido('Saída')",
  @keyup.esc="redirecionarParaTelaDeSenha"
)
  .current-time-container
      CurrentTime(v-if="mostrarRelogio")

  template(v-if="validandoInformacoesPreMarcacao")
    div.column.has-text-centered
      h1 {{ $t('componentes.marcacao.views.marcacao.tituloValidando') }}...

  template(v-if="exibirTelaDeSincronizacaoDeHorario && !validandoInformacoesPreMarcacao")
    div.column.has-text-centered
      h1 {{ $t('componentes.marcacao.views.marcacao.tituloSincronizando') }}...

  template(v-if="processandoPonto")
    div.column.has-text-centered
      h1(v-if="processandoPonto") {{ $t('componentes.marcacao.views.marcacao.tituloProcessando') }}...

  template(v-if="!processandoPonto && !exibirTelaDeSincronizacaoDeHorario && !validandoInformacoesPreMarcacao")
    .has-text-centered
      div(v-if="configPonto.omitirBotoesDePausa")
        .columns
          .column
            PtButton(:displayPts="marcacoesDoDia.entrada", kind="ENTRADA", :recordingKind="recordingStart", :recording="recording", :seconds="seconds" , id="botaoentrada", omitirPausa=true @marcarPonto="validarPontoASerBatido")

          .column
            PtButton(:displayPts="marcacoesDoDia.saida", kind="SAÍDA", :recordingKind="recordingEnd", :recording="recording", :seconds="seconds" , omitirPausa=true @marcarPonto="validarPontoASerBatido")
      div(v-else)
        .columns
          .column
            PtButton(:displayPts="marcacoesDoDia.entrada", kind="ENTRADA", :recordingKind="recordingStart", :recording="recording", :seconds="seconds" , id="botaoentrada", omitirPausa=false @marcarPonto="validarPontoASerBatido")

          .column
            PtButton(:displayPts="marcacoesDoDia.pausa", kind="PAUSA", :recordingKind="recordingStPause", :recording="recording", :seconds="seconds" , omitirPausa=false @marcarPonto="validarPontoASerBatido")

        .columns
          .column
            PtButton(:displayPts="marcacoesDoDia.retorno", kind="RETORNO PAUSA", :recordingKind="recordingEndPause", :recording="recording", :seconds="seconds" , omitirPausa=false @marcarPonto="validarPontoASerBatido")

          .column
            PtButton(:displayPts="marcacoesDoDia.saida", kind="SAÍDA", :recordingKind="recordingEnd", :recording="recording", :seconds="seconds" , omitirPausa=false @marcarPonto="validarPontoASerBatido")

      .botoes-inferiores(:style="quantidadeDeBotoesRodape")
        BotaoRedondo(v-if="mostrarBotaoVoltar" :titulo="$t('componentes.marcacao.views.marcacao.botaoVoltar')" @click="redirecionarParaTelaDeSenha")
          img(src="../../../../static/icones/svg/setaEsquerda.svg")
        BotaoRedondo(:titulo="$t('componentes.marcacao.views.marcacao.botaoPontosRegistrados')" @click="direcionarParaTelaDeHistoricoDeMarcacao")
          img(src="../../../../static/icones/svg/calendario.svg")
        BotaoRedondo(v-if="possuiModuloPedidoHorasExtras" :titulo="$t('componentes.marcacao.views.marcacao.botaoPedirHorasExtras')" @click="redirecionarParaTelaDePedirHorasExtras")
          img(src="../../../../static/icones/svg/adicionarHorario.svg")
</template>
<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import CurrentTime from '@/common/CurrentTime.vue'
import BotaoRedondo from '@/common/buttons/BotaoRedondo.vue'
import PtButton from '../Components/PtButton.vue'
import ModalDeConfirmacaoDePontoSemVoz from '../Components/ModalDeConfirmacaoDePontoSemVoz.vue'

export default {
  name: 'Marcacao',
  components: { CurrentTime, PtButton, BotaoRedondo },
  data () {
    return {
      processoMarcacaoIniciado: false,
      storage: 'permissaoMicrofoneNaoConcedida',
      seconds: 3,
      recordingStart: false,
      recordingStPause: false,
      recordingEndPause: false,
      recordingEnd: false,
      recording: false,
      periodicSSOPtsUpdaterWorker: false,
      temporizadorRedirecionamentoPin: null
    }
  },
  created () {
    this.$store.commit('marcacao/atribuiValidandoPreMarcacao', true)
    const empregado = this.$store.state.marcacao.empregadoId
    const estaLogadoComSAML = this.$store.state.accessData.cognitoInfo && this.$store.state.accessData.cognitoInfo.isSamlLogin
    const estaLogadoComSSOSolar = this.$store.state.accessData.solarInfo
    if (!empregado) {
      this.$router.push({name: 'sincronizador'})
    }
    if (estaLogadoComSAML || estaLogadoComSSOSolar) {
      this.startPeriodicSSOPtsUpdater()
    } else if ((estaLogadoComSAML || estaLogadoComSSOSolar) && !empregado) {
      this.$store.dispatch('sincronizador/fazerSincronizacaoWebSSO', {})
    } else {
      this.iniciarTemporizadorDeRedirecionamentoParaPin()
    }
  },
  mounted () {
    this.verificacoesDaExibicaoModalDeConfirmacaoDePontoSemVoz()
    this.$store.dispatch('marcacao/enviarInfosExtrasEmSegundoPlano')
  },
  beforeDestroy () {
    if (this.temporizadorRedirecionamentoPin) {
      clearInterval(this.temporizadorRedirecionamentoPin)
    }
  },
  computed: {
    ...mapGetters(['visual']),
    ...mapGetters('sincronizador', ['possuiModuloPedidoHorasExtras']),
    mostrarRelogio () {
      return this.$store.state.marcacao.mostrarRelogio
    },
    validandoInformacoesPreMarcacao () {
      return this.$store.state.marcacao.validandoPreMarcacao
    },
    exibirTelaDeSincronizacaoDeHorario () {
      const localDeTrabalhoMarcacao = this.$store.state.marcacao.localDeTrabalhoMarcacao

      if (!localDeTrabalhoMarcacao) return false

      const aceitaTimezoneDoColetor = localDeTrabalhoMarcacao.aceita_timezone_do_coletor
      const horarioDaGeolocalizacaoCarregado = this.$store.state.marcacao.horarioDaGeolocalizacaoCarregado
      const erroDeGeolocalizacao = this.$store.state.marcacao.erroDeGeolocalizacao

      if (!aceitaTimezoneDoColetor || erroDeGeolocalizacao) return false
      if (aceitaTimezoneDoColetor && !horarioDaGeolocalizacaoCarregado) {
        return true
      }
      return false
    },
    configPonto () {
      return {
        marcacaoVoz: this.$store.state.marcacao.opcoesDeMarcacao.ativarMarcacaoVoz,
        omitirBotoesDePausa: this.$store.state.marcacao.opcoesDeMarcacao.omitirBotoesDePausa
      }
    },
    marcacoesDoDia () {
      const jornadaEmAndamento = this.$store.getters['sincronizador/marcacoesDaJornadaEmAndamento']

      if (!jornadaEmAndamento) {
        return {
          entrada: [],
          pausa: [],
          retorno: [],
          saida: []
        }
      }

      return jornadaEmAndamento
    },
    processandoPonto () {
      return this.$store.state.marcacao.processandoPonto
    },
    empregaUsaPontoComVoz () {
      return this.$store.state.marcacao.opcoesDeMarcacao.ativarMarcacaoVoz
    },
    empregadoPodeOcultarModalDeConfirmacaoDePontoSemVoz () {
      return this.$store.state.marcacao.opcoesDeMarcacao.forcarModalDeRequisicaoVoz === false
    },
    memorizadorParseado () {
      const {storage} = this
      const memorizadorLocal = localStorage.getItem(storage)
      if (!memorizadorLocal) {
        return {}
      }
      return JSON.parse(memorizadorLocal)
    },
    empregadoOcultouModalDeConfirmacaoDePontoSemVoz () {
      if (this.empregadoPodeOcultarModalDeConfirmacaoDePontoSemVoz) {
        const idDoEmpregado = this.$store.state.marcacao.empregadoId
        return this.memorizadorParseado[idDoEmpregado]
      }
      return false
    },
    exibirModalDeConfirmacaoDaMarcacao () {
      return this.$store.state.marcacao.opcoesDeMarcacao.exibirModalDeConfirmacaoDaMarcacao
    },
    mostrarBotaoVoltar () {
      const estaLogadoComSAML = this.$store.state.accessData.cognitoInfo && this.$store.state.accessData.cognitoInfo.isSamlLogin
      const estaLogadoComSSOSolar = this.$store.state.accessData.solarInfo
      if (
        (estaLogadoComSAML || estaLogadoComSSOSolar) &&
        !this.$store.state.sincronizador.sincronizacaoWeb.perfil_de_coletor.opcoes.seguranca.confirmar_dados
      ) {
        return false
      } else if (this.visual.webButtonBack) {
        return true
      }
      return false
    },
    quantidadeDeBotoesRodape () {
      const mostrarBotaoVerPontos = true
      const botoes = [this.mostrarBotaoVoltar, mostrarBotaoVerPontos, this.possuiModuloPedidoHorasExtras]

      return {
        '--quantidadeBotoesRodape': botoes.filter(Boolean).length
      }
    }
  },
  methods: {
    verificacoesDaExibicaoModalDeConfirmacaoDePontoSemVoz () {
      if (!this.empregaUsaPontoComVoz) return
      if (!this.empregadoPodeOcultarModalDeConfirmacaoDePontoSemVoz) {
        this.resetarNaoMostrarNovamenteDefinidoPeloEmpregado()
      }
      if (this.empregadoOcultouModalDeConfirmacaoDePontoSemVoz) {
        return
      }
      this.verificarPermissaoDeUsoDoMicrofone()
    },
    resetarNaoMostrarNovamenteDefinidoPeloEmpregado () {
      const {memorizadorParseado} = this
      const idDoEmpregado = this.$store.state.marcacao.empregadoId
      delete memorizadorParseado[idDoEmpregado]
      localStorage.setItem(this.storage, JSON.stringify(memorizadorParseado))
    },
    async verificarPermissaoDeUsoDoMicrofone () {
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: true
        })
      } catch (erro) {
        if (erro instanceof DOMException) {
          this.mostrarModalDeConfirmacaoDePontoSemVoz()
        }
      }
    },
    async mostrarModalDeConfirmacaoDePontoSemVoz () {
      const idDoEmpregado = this.$store.state.marcacao.empregadoId
      const modal = new Vue({
        ...ModalDeConfirmacaoDePontoSemVoz,
        parent: this,
        propsData: {
          storage: this.storage,
          chave: idDoEmpregado,
          exibirNaoMostrarNovamente: this.empregadoPodeOcultarModalDeConfirmacaoDePontoSemVoz
        }
      }).$mount()

      const resposta = await this.$swal({
        type: 'warning',
        title: 'Permissão ao microfone não concedida',
        html: modal.$el,
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonText: 'registrar sem voz',
        confirmButtonText: 'voltar',
        allowOutsideClick: false
      })

      const selecionouVoltar = resposta.value === true
      if (selecionouVoltar) {
        this.redirecionarParaTelaDeSenha()
      }
    },
    enviarMarcacao () {
      this.$store.dispatch('marcacao/fazerMarcacao')
    },
    tiposDePonto () {
      return {
        'Entrada': [this.marcacoesDoDia.entrada, 'Entrada'],
        'Pausa': [this.marcacoesDoDia.pausa, 'Pausa'],
        'Retorno Pausa': [this.marcacoesDoDia.retorno, 'Retorno'],
        'Saída': [this.marcacoesDoDia.saida, 'Saida']
      }
    },
    validarPontoASerBatido (kind) {
      const omitirBotoesDePausa = this.configPonto.omitirBotoesDePausa
      const ehPontoDePausa = ['Pausa', 'Retorno Pausa'].includes(kind)

      if (omitirBotoesDePausa && ehPontoDePausa) return
      if (this.processoMarcacaoIniciado) return
      this.$store.commit('marcacao/atribuiMomentoDaJornada', kind)

      if (this.exibirModalDeConfirmacaoDaMarcacao && (this.tiposDePonto()[kind][0].length === 0)) {
        const tipoPontoTraduzido = this.$t(`componentes.marcacao.componentes.ptButton.displayInfo.tipo${this.tiposDePonto()[kind][1]}`)
        const mensagemTraduzida = this.$t('componentes.marcacao.views.marcacao.validarPontoASerBatido.modal.texto')

        this.$swal({
          type: 'question',
          text: `${mensagemTraduzida} ${tipoPontoTraduzido}?`,
          showCancelButton: true,
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim',
          onOpen: function () {
            const elementos = document.querySelectorAll('.swal2-content, .swal2-header')
            elementos.forEach(function (elemento) {
              elemento.setAttribute('aria-hidden', 'true')
            })
          }
        }).then((result) => {
          if (result.value) {
            this.baterPonto(kind)
          }
        })
      } else {
        this.baterPonto(kind)
      }
    },
    baterPonto (kind) {
      if (this.recording || this.processandoPonto) {
        this.$swal({
          type: 'info',
          text: this.$t('componentes.marcacao.views.marcacao.baterPonto.modalGravando.texto'),
          confirmButtonText: this.$t('componentes.marcacao.views.marcacao.baterPonto.modalGravando.botaoConfirmar')
        })
      } else if (this.tiposDePonto()[kind][0].length !== 0) {
        const tipoDoPonto = this.tiposDePonto()[kind][1]
        const mensagemTraduzida = this.$t(`componentes.marcacao.componentes.ptButton.displayInfo.tipo${tipoDoPonto}`)
        this.$swal({
          type: 'question',
          text: `${this.$t('componentes.marcacao.views.marcacao.baterPonto.modalMesmoTipo.texto1')} ${mensagemTraduzida}. ${this.$t('componentes.marcacao.views.marcacao.baterPonto.modalMesmoTipo.texto2')}?`,
          showCancelButton: true,
          cancelButtonText: this.$t('componentes.marcacao.views.marcacao.baterPonto.modalMesmoTipo.botaoCancelar'),
          confirmButtonText: this.$t('componentes.marcacao.views.marcacao.baterPonto.modalMesmoTipo.botaoConfirmar'),
          onOpen: function () {
            const elementos = document.querySelectorAll('.swal2-content, .swal2-header')
            elementos.forEach(function (elemento) {
              elemento.setAttribute('aria-hidden', 'true')
            })
          }
        }).then((result) => {
          if (result.value) {
            if (this.empregaUsaPontoComVoz) {
              this.startRecord(kind)
            } else {
              this.enviarMarcacao()
            }
          }
        })

        document.querySelector('.swal2-confirm.swal2-styled').setAttribute('id', 'confirmapontorepetido')
      } else {
        if (this.empregaUsaPontoComVoz) {
          this.startRecord(kind)
        } else {
          this.enviarMarcacao()
        }
      }
    },
    redirecionarParaTelaDeSenha () {
      const estaLogadoComSAML = this.$store.state.accessData.cognitoInfo && this.$store.state.accessData.cognitoInfo.isSamlLogin
      const estaLogadoComSSOSolar = this.$store.state.accessData.solarInfo
      if (
        (estaLogadoComSAML || estaLogadoComSSOSolar) &&
        this.$store.state.sincronizador.sincronizacaoWeb.perfil_de_coletor.opcoes.seguranca.confirmar_dados
      ) {
        this.$router.push({ name: 'confirmacaoDados' })
      } else {
        this.$router.push({ name: 'sincronizador' })
      }
    },
    redirecionarParaTelaDePedirHorasExtras () {
      this.$router.push({ name: 'solicitacaoHorasExtras' })
    },
    resetRecording () {
      this.recording = false
      this.recordingStart = false
      this.recordingStPause = false
      this.recordingEndPause = false
      this.recordingEnd = false
    },
    setRecording (kind) {
      this.recording = true
      if (kind === 'Entrada') {
        this.recordingStart = true
      } else if (kind === 'Pausa') {
        this.recordingStPause = true
      } else if (kind === 'Retorno Pausa') {
        this.recordingEndPause = true
      } else if (kind === 'Saída') {
        this.recordingEnd = true
      } else {
        this.recording = false
      }
    },
    startRecord (kind) {
      function hasGetUserMedia () {
        return !!(navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia)
      }

      if (hasGetUserMedia()) {
        navigator.mediaDevices.getUserMedia({audio: true})
          .then(stream => {
            this.setRecording(kind)
            const mediaRecorder = new MediaRecorder(stream)

            mediaRecorder.start()
            const audioChunks = []

            mediaRecorder.addEventListener('dataavailable', event => {
              audioChunks.push(event.data)
            })
            mediaRecorder.addEventListener('stop', () => {
              const audioBlob = new Blob(audioChunks)

              this.$store.commit('marcacao/atribuiAudioGravado', audioBlob)
              this.resetRecording()
              this.enviarMarcacao()
            })

            setTimeout(() => {
              mediaRecorder.stop()
            }, 3000)

            setInterval(() => this.seconds--, 1000)
          }).catch(e => {
            console.warn('Usuário não permitiu acesso ao microfone, prosseguindo com marcação de ponto normal')
            this.resetRecording()
            this.enviarMarcacao()
          })
      } else {
        console.warn('dont have enough information')
        alert('getUserMedia() is not supported by your browser')
      }
    },
    direcionarParaTelaDeHistoricoDeMarcacao () {
      this.$router.push({ name: 'historicoMarcacao' })
    },
    startPeriodicSSOPtsUpdater () {
      if (this.$store.state.workerSSOAtivo) return

      const {origin, pathname} = window.location
      this.periodicSSOPtsUpdaterWorker = new Worker(`${origin}${pathname}js/setIntervalWorker.js`)
      this.$store.commit('workerSSOAtivo', true)

      this.periodicSSOPtsUpdaterWorker.addEventListener('message', (e) => {
        this.$store.dispatch('sincronizador/fazerSincronizacaoWebSSO', {})
      })

      this.periodicSSOPtsUpdaterWorker.postMessage(true)
    },
    iniciarTemporizadorDeRedirecionamentoParaPin () {
      this.temporizadorRedirecionamentoPin = setTimeout(() => {
        this.$router.push({name: 'sincronizador'})
      }, 360000)
    }
  },
  watch: {
    seconds: function (val) {
      if (val <= 0) {
        const opcoesDeMarcacao = this.$store.state.marcacao.opcoesDeMarcacao
        this.$store.commit('marcacao/atribuiOpcoesDeMarcacao', {...opcoesDeMarcacao, ativarMarcacaoVoz: false}, { root: true })
      }
    }
  }
}
</script>

<style scoped>
.current-time-container {
  height: 100px;
  display: flex;
  justify-content: center;
  margin: 0;
}
.outline {
  outline: none;
}

.container-pts {
  margin: 0;
  display: grid;
  grid-template-columns: 1fr;
  /*grid-template-rows: 0.fr 1fr 0.01fr;*/
}
.container-pts h1 {
  margin: 0;
  align-self: center;
}

.botoes-inferiores {
  display: grid;
  grid-template-columns: repeat(var(--quantidadeBotoesRodape, 3), 100px);
  gap: 50px;
  justify-content: center;
  margin-top: 40px;
  align-items: flex-start;
}

@media only screen and (min-width: 1000px) {
  .container-pts {
    width: 100%;
    padding: 0 25% 0 25%;
  }
}

@media only screen and (min-width: 800px) and (max-width: 1000px) {
  .container-pts {
    width: 100%;
    padding: 0 15% 0 15%;
    grid-template-rows: 0.1fr 0.8fr;
  }
}

@media only screen and (max-width: 800px) and (min-width: 600px) {
  .container-pts {
    width: 100%;
    padding: 0 10% 0 10%;
    grid-template-rows: 0.1fr 0.8fr;
  }
}

@media only screen and (max-width: 600px) {
  .container-pts {
    width: 100%;
    padding: 0 7% 0 7%;
    grid-template-rows: 0.1fr 0.8fr;
  }

  .botoes-inferiores {
    gap: unset;
  }
}
</style>
